import React from 'react'
import { Links } from '../../settings/links'

export const MODERATOR_ROLE = 1

export type MenuItemConfig = {
  translationKey: string
  href: string
  isExternal?: boolean
  requiresModerator?: boolean
}

export type MenuLinkItem = {
  translationKey: string
  to: string
  isExternal?: boolean
  onClick?: (e: React.MouseEvent) => void
}

export type MenuItemWithLabel = MenuItemConfig & { label: string }
export type MenuLinkItemWithLabel = MenuLinkItem & { label: string }

export const useMenuItems = (
  t: (key: string) => string,
  user: { role: number; userId: string | number | null },
  authRedirectHandle: (
    e: React.MouseEvent,
    path: string,
    redirectPath: string
  ) => void
) => {
  const mainMenuItems: MenuLinkItem[] = [
    {
      translationKey: 'header.menu.donate',
      to: '/donate',
      onClick: (e) => authRedirectHandle(e, '/donate', '/donate'),
    },
    {
      translationKey: 'header.menu.search',
      to: '/search',
      isExternal: false,
    },
  ]

  const conditionalMenuItems: MenuLinkItem[] = [
    {
      translationKey: 'header.menu.moderatorView',
      to: '/moderation',
      isExternal: false,
    },
    {
      translationKey: 'header.menu.nonprofitCatalog',
      to: '/nonprofit-catalog',
      isExternal: false,
    },
  ]

  const dropdownMenuItems: MenuItemConfig[] = [
    {
      translationKey: 'header.menu.about',
      href: '/about',
      isExternal: false,
    },
    {
      translationKey: 'header.menu.forNonprofits',
      href: Links.charities,
      isExternal: true,
    },
    {
      translationKey: 'header.menu.termsForServices',
      href: Links.terms,
      isExternal: true,
    },
  ]

  const helpMenuItem: MenuLinkItem = {
    translationKey: 'header.menu.help',
    to: Links.help,
    isExternal: true,
  }

  const selectedConditionalItem =
    user.role === MODERATOR_ROLE
      ? conditionalMenuItems[0]
      : conditionalMenuItems[1]

  return {
    mainItems: mainMenuItems.map((item) => ({
      ...item,
      label: t(item.translationKey),
    })) as MenuLinkItemWithLabel[],
    conditionalItem: {
      ...selectedConditionalItem,
      label: t(selectedConditionalItem.translationKey),
    } as MenuLinkItemWithLabel,
    helpItem: {
      ...helpMenuItem,
      label: t(helpMenuItem.translationKey),
    } as MenuLinkItemWithLabel,
    dropdownItems: dropdownMenuItems.map((item) => ({
      ...item,
      label: t(item.translationKey),
    })) as MenuItemWithLabel[],
  }
}

